import { buildBorderBackgroundAlpha, dilateMask, createLayerFromAlpha } from './imageUtils'
import { buildPersonAvatarCutout } from './segmenter'

export const buildBorderAvatarCutout = ({ avatarImage, settings, segmenterImage } = {}) => {
  try {
    if (!avatarImage?.img) return null
    const w = avatarImage.img.naturalWidth || avatarImage.img.width
    const h = avatarImage.img.naturalHeight || avatarImage.img.height
    if (!(w > 0 && h > 0)) return null

    // Try person segmentation first (proper subject detection)
    if (segmenterImage) {
      const personCutout = buildPersonAvatarCutout(avatarImage, segmenterImage, w, h, settings)
      if (personCutout) return personCutout
    }

    // Fallback to border-based background removal
    const bgAlpha = buildBorderBackgroundAlpha(avatarImage.img, w, h, { threshold: 30 })
    const subjectAlpha = new Uint8ClampedArray(w * h)
    for (let p = 0; p < w * h; p += 1) subjectAlpha[p] = 255 - (bgAlpha[p] || 0)
    const softenRadius = Math.max(0, Math.min(4, Math.round(Number(settings.featherPx) || 0)))
    const softened = softenRadius > 0 ? dilateMask(subjectAlpha, w, h, softenRadius) : subjectAlpha
    const canvas = createLayerFromAlpha(avatarImage.img, w, h, softened)
    return canvas
  } catch (e) {
    return null
  }
}

export default { buildBorderAvatarCutout }
